const API_ROOT = process.env.API_ROOT;

export {
    API_ROOT
};